export default {
  "iso3": "ita",
  "iso2": "it",
  "text": {
    "100200": "Spiacenti, questo gioco non è ammesso nella tua area.",
    "CURRENT_LANGUAGE": "English",
    "CIP8_TITLE": "GIOCHI DA 888CASINO",
    "Login": "LOGIN",
    "WITHDRAW": "PRELIEVO",
    "CASHIER": "Cassa",
    "Search": "Cerca il tuo gioco...",
    "REWARDS": "Premi",
    "HOME": "Home",
    "888_COM": "888.com",
    "888_POKER": "poker",
    "888_CASINO": "casinò",
    "888_SPORT": "sport",
    "SIGN_UP": "REGISTRATI",
    "DEPOSIT_SIDE_MENU": "Ricarica",
    "MY_ACCOUNT": "Mio Conto",
    "BALANCE": "Saldo corrente",
    "LOGOUT": "Esci",
    "GREETING_MORNING": "Buongiorno",
    "GREETING_AFTERNOON": "Buon pomeriggio",
    "GREETING_EVENING": "Buonasera",
    "GREETING_NIGHT": "Buonanotte",
    "GREETING_DEFAULT": "Salve",
    "MRS_TITLE": "Sig.ra",
    "MR_TITLE": "Sig.",
    "SLOTS": "Slot",
    "LOBBY": "Lobby",
    "SLOTS_JACKPOTS": "Slot e Jackpot",
    "CARD_TABLE_GAMES": "Giochi di carte e da tavolo",
    "CASINO_GAMES": "Giochi da casinò",
    "LIVE_CASINO": "Live Casino",
    "PROMOTIONS": "Promozioni",
    "888SPORT": "Sport",
    "VIP_CLUB": "VIP",
    "PWA_INSTALL": "Installa l'app",
    "PWA_ADD_TO_HOME_SCREEN": "Aggiungere alla schermata iniziale",
    "PWA_TAP": "Clicca su",
    "PWA_QUICK_LAUNCH": "Avvio rapido {BRAND}",
    "BLOG": "Blog",
    "TODAY_WINNERS": "I vincitori di oggi",
    "SUPPORT_ID_MESSAGE": "ID assistenza",
    "DEPOSIT": "RICARICA",
    "SIGN_IN_PLAY": "REGISTRATI E GIOCA",
    "NEW": "Novità",
    "JACKPOT": "Jackpot",
    "BRAND_EXCLUSIVE_FILTER": "Esclusivo {brandName}",
    "EXCLUSIVE": "Esclusivo 888",
    "SI_EXCLUSIVE": "Esclusivo SI",
    "HOTTEST_NEW_GAMES": "I nuovi giochi più popolari",
    "BRAND_NEW": "Novità assoluta",
    "SINCE_LAST_MONTH": "Dal mese scorso",
    "FROM_LAST_MONTH": "From Last Month",
    "SAFE_GAMBLING_TOOLTIP": "Informazioni e strumenti per un gioco più sicuro",
    "1-25_LINES": "1-25 linee",
    "25+_LINES": "25+ linee",
    "INFO_TITLE_ARENA_888_EXCLUSIVE_GAMES": "Giochi da casinò esclusivi",
    "INFO_TEXT_ARENA_888_EXCLUSIVE_GAMES": "888casino offre giochi di casinò in esclusiva realizzati dal nostro sviluppatore interno Section8: Roulette online, Blackjack online e Video Poker, ma anche Slot Online, Instant Games e grandi classici da casinò come Baccarat. Ti aspetta un grande divertimento con i giochi Section 8.",
    "INFO_TITLE_ARENA_SLOTS": "Slot online",
    "INFO_TEXT_ARENA_SLOTS": "Oltre 100 giochi di Slot a disposizione per darti in ogni momento la scelta più ampia possibile: dalle Slot machine classiche alle più moderne Video Slot con Scatter, simboli Wild e Giocate Gratis, il divertimento delle slot su 888casino non si ferma mai! Prova a centrare il Jackpot con il Genio della lampada, oppure cerca il tesoro dei pirati o la pentola d’oro alla fine dell’arcobaleno: ogni giro di rulli può essere quello giusto con le Slot di 888casino!",
    "INFO_TITLE_ARENA_CASINO": "Giochi da casinò",
    "INFO_TEXT_ARENA_CASINO": "Il grande fascino dei classici giochi da casinò direttamente sul tuo computer o sul tuo dispositivo mobile: su 888casino puoi trovare le principali varianti di Roulette e tantissimi tavoli di Blackjack, per darti la possibilità di trovare il gioco adatto alle tue tasche, ma ci sono anche Baccarat, Punto Banco, Dadi e diverse versioni di Poker contro il banco.",
    "INFO_TITLE_ARENA_ROULETTE": "Roulette online",
    "INFO_TEXT_ARENA_ROULETTE": "Prova a scegliere i tuoi numeri fortunati in uno dei tavoli dell'esclusiva roulette online di 888casino. Gioca con quella che preferisci: l'europea, l'americana o la francese. Puoi essere un \"High Roller\" o un giocatore più prudente, troverai sempre la roulette adatta ai tuoi gusti. Nessun altro gioco ti regala più emozioni: pensa alla pallina che gira per poi fermarsi sul tuo numero fortunato!",
    "INFO_TITLE_ARENA_NEW_GAMES": "Nuovi Giochi",
    "INFO_TEXT_ARENA_NEW_GAMES": " ",
    "INFO_TITLE_ARENA_BLACKJACK": "Blackjack online",
    "INFO_TEXT_ARENA_BLACKJACK": "Le carte vengono mescolate... preparati quindi a divertirti con i giochi di Blackjack online migliori della rete! Gioca al Blackjack di 888casino con le scommesse super, le puntate secondarie e altre funzioni. Non ti basta una sola mano di Blackjack? Divertiti allora con il nostro Multihand Blackjack: avrai tre possibilità di ottenere un '21' contemporaneamente!",
    "INFO_TITLE_ARENA_VIDEO_POKER": "Video Poker online",
    "INFO_TEXT_ARENA_VIDEO_POKER": "Se pensi di essere un vero professionista del poker? Allora, sei arrivato nel casinò giusto! Cerca di ottenere una Scala reale massima con i tantissimi tipi di video poker a tua disposizione. Puoi scegliere la classica mano con 5 carte oppure il famosissimo Texas Hold’em... in ogni caso con 888casino troverai il gioco più adatto a te.",
    "INFO_TITLE_ARENA_SCRATCH_CARDS": "Instant Games online",
    "INFO_TEXT_ARENA_SCRATCH_CARDS": "I \"Instant Games\" di 888casino sono pronti a regalarti tante vincite immediate. Solo la scelta ideale per chi vuole divertirsi senza una strategia precisa. Ti basta solo scegliere il &quot;Instant Games&quot; che preferisci. Scopri i tesori della verde Irlanda oppure le ricchezze dei faraoni... la scelta è solo tua. Seleziona l'importo che vuoi scommettere e scopri se hai vinto!",
    "NETENT_SLOTS": "NETENT SLOTS",
    "BONUS": "Bonus",
    "FREE_SPINS": "Giocate gratis",
    "CLEAR_ALL": "Rimuovi tutto",
    "FILTER": "Filtra",
    "APPLY": "Applica",
    "ROULETTE": "Roulette",
    "BLACKJACK": "Blackjack",
    "BACCARAT": "Baccarat",
    "POKER": "Poker",
    "KENO": "Keno",
    "HIGH_LIMIT": "Limite alto",
    "LANGUAGES": "Lingue",
    "HELP": "Guida",
    "LIVE_CHAT": "Chat live",
    "DEMO": "Demo",
    "PLAY": "Gioca",
    "NOT_NOW": "Non ora",
    "MAYBE_LATER": "Non ora",
    "NO_THANKS": "No, grazie",
    "LETS_PLAY": "Giochiamo!",
    "GOT_IT": "GOT IT!",
    "LIMITS": "Limiti",
    "LIVE": "Live",
    "SEE_ALL": "Vedi tutti",
    "WINNING_IN_THE_LAST_30_DAYS": "Vincenti degli ultimi 30 giorni",
    "TOTAL_JACKPOTS": "Jackpot totali",
    "TOP_GAMES": "TOP SLOT",
    "LIVE_CASINO_TABLES": "TAVOLI LIVE PREFERITI",
    "TOP_CASINO_GAMES": "I PIÙ GIOCATI",
    "JACKPOTS": "JACKPOT",
    "RECENTLY_PLAYED": "Scelti di recente",
    "BECAUSE_YOU_PLAYED": "Perché hai giocato a {gameName}",
    "MINIMUM_BET": "Puntata min.",
    "MAXIMUM_BET": "Puntata max",
    "PAYLINES": "Linee vincenti",
    "BONUS_GAME": "Giocata Bonus",
    "MAX_PER_SPOT": "Max per area",
    "MULTIPLAYER": "Multigiocatore",
    "DECKS": "Mazzi",
    "SIDE_BETS": "Puntate secondarie",
    "ABOUT": "Descrizione del gioco",
    "GAME_JACKPOT": "Jackpot del gioco",
    "SLOT_GAMES": "Slot",
    "CARD_AND_TABLE_GAMES": "Giochi di carte e da tavolo",
    "JACKPOT_GAMES": "Giochi con jackpot",
    "JACKPOT_CENTRAL": "Jackpot Games",
    "OTHER": "Altro",
    "POKER_GAMES": "GIOCHI DI POKER",
    "YOUR_SEARCH_DID_NOT_MATCH_ANY_GAMES": "La tua ricerca non ha individuato alcun gioco",
    "PREMIER_ONLINE_LIVE_CASINO": "Casinò live premier",
    "All_SLOTS": "Tutte le slot",
    "All_CARD_AND_TABLE_GAMES": "Tutti i giochi di carte e da tavolo",
    "USEFUL_LINKS": "Link utili",
    "PRIVACY_POLICY": "Politica della Privacy",
    "USER_AGREEMENT": "Accordo con l'utente",
    "RESPONSIBLE_GAMBLING": "Gioco responsabile",
    "SAFE_ZONE": "Centro di Controllo",
    "CONTACT": "Contatti",
    "COMP_POINTS": "Punti Bonus",
    "HISTORY": "Cronologia",
    "GAMING_HISTORY": "Cronologia di gioco",
    "TIPPING_HISTORY": "Cronologia mance",
    "TIPPING_HISTORY_AMOUNT": "Importo mancia",
    "MY_CHALLENGES": "Le mie missioni",
    "SCRATCHCARDS": "Grattini",
    "QUICK_LINKS_TITLE": "LINK RAPIDI",
    "NO_SEARCH_RESULTS": "Nessun risultato di ricerca trovato...",
    "SEARCH_YOUR_GAME": "Trova Giochi, Temi, Produttore",
    "SEARCH_RESULTS_TITLE": "MIGLIORI RISULTATI DI RICERCA",
    "SUGGESTED_GAMES": "GIOCHI SUGGERITI",
    "SUGGESTED_CATEGORIES": "CATEGORIE SUGGERITE",
    "BACK": "Indietro",
    "OUR_JACKPOTS": "I NOSTRI JACKPOT",
    "CASH_BALANCE": "Denaro",
    "BONUS_BALANCE": "Bonus",
    "GAMBLING_WARNING_part1": "Il gioco è vietato ai minori e può causare dipendenza patologica. Clicca per ",
    "GAMBLING_WARNING_part2": " o per ",
    "YOU_MAY_LIKE": "TI POTREBBE PIACERE",
    "HIT_THE_JACKPOT": "CONTINUA",
    "TOP_PICKS_FOR": "SCELTE MIGLIORI PER {USERNAME}",
    "888CLUB": "888club",
    "888POKER": "Poker",
    "MY_CLUB": "Il mio club",
    "BACK_TO_888POKER": "Torna al 888poker",
    "BACK_TO_888SPORT": "Torna al 888sport",
    "VIDEO_POKER_GAMES": "Giochi di Video poker",
    "VIDEO_POKER": "Video Poker",
    "SEO_IMAGE_CATEGORIES_TITLE": "La migliore esperienza {categoryName} su 888casino",
    "SEO_IMAGE_CATEGORIES_ALT": "Casinò online - {categoryName}",
    "SEO_IMAGE_GAME_TITLE": "{gameName} {categoryName}",
    "LOW_ROLLERS": "Low Rollers",
    "TOP_NETENT_SLOTS": "LE MIGLIORI SLOT NETENT",
    "PLAY_50_FREESPINS": "GIOCA 50 GIOCATE GRATIS",
    "HOLIDAY_GAMES": "Giochi delle vacanze",
    "FESTA_GAMES": "Festa di San Patrizio",
    "ELITE_LOUNGE": "Elite Lounge",
    "ORIGINALS": "Originali 888",
    "RELATED_GAMES": "PERCHÉ HAI SCELTO: {gameName}",
    "DAILY_JACKPOT_GAMES": "Giochi con Jackpot giornalieri",
    "CLASSIC_SLOTS": "Slot classiche",
    "ALL_JACKPOTS": "TUTTI I JACKPOT",
    "POPULAR_GAMES_TITLE": "Giochi popolari",
    "MORE": "Più",
    "GAMES": "Giochi",
    "HOMEPAGE-SPOOKY_SPINS": "Spooky Spins",
    "THE_DAILY_JACKPOT": "JACKPOT GIORNALIERO 888",
    "HIGH_NOON_JACKPOT": "Jackpot di mezzogiorno",
    "TWILIGHT_JACKPOT": "Jackpot Twilight",
    "POWER8_JACKPOT": "POWER 8 JACKPOT",
    "RED_TIGER_DAILY_JACKPOT": "JACKPOT GIORNALIERO RED TIGER",
    "RED_TIGER_HOURLY_JACKPOT": "Jackpot orario Red Tiger",
    "PROGRESSIVE_JACKPOTS": "JACKPOT PROGRESSIVI",
    "INFO_TITLE_ARENA_JACKPOTS": "Giochi con Jackpot",
    "INFO_TEXT_ARENA_JACKPOTS": "I giochi con Jackpot mettono in palio ricchissimi premi in denaro in aggiunta alle vincite normali. Su 888casino hai tantissimi giochi con Jackpot, tra cui i Jackpot fissi e i famosi Jackpot progressivi, come ad esempio quello offerto da Millionaire Genie.",
    "INSTANT_GAMES": "Instant Win Games",
    "INSTANT_WIN_GAMES_ARENA": "Instant Win Games",
    "ALL_INSTANT_WIN_GAMES": "TUTTI I GIOCHI CON VINCITA IMMEDIATA",
    "INFO_TITLE_ARENA_INSTANT_WIN_GAMES": "Giochi Con Vincita Immediata",
    "INFO_TEXT_ARENA_INSTANT_WIN_GAMES": "Divertenti e facili da usare, gli Instant Games sono il passatempo ideale per chi cerca uno svago più veloce ed immediato rispetto ai tradizionali giochi da casinò. Con gli Instant Games infatti bastano pochi istanti per scoprire le tessere e vedere se hai ottenuto i simboli vincenti: divertimento assicurato ed immediato con Foxin’ Wins, Panda Mania, Gorilla Go Wild e gli altri Instant Games di 888casino.",
    "888_EXCLUSIVE_GAMES": "Giochi esclusivi 888",
    "TRENDING_SLOTS": "LE SLOT PIÙ AMATE",
    "EXCLUSIVE_LIVE_TABLES": "TAVOLI LIVE ESCLUSIVI",
    "BLACKJACK_AND_ROULETTE_GAMES": "GIOCHI DI BLACKJACK E ROULETTE",
    "ALL_888_EXCLUSIVE_GAMES": "TUTTI I GIOCHI ESCLUSIVI DI 888",
    "LIVE_ARENA_TABLE_IS_CLOSED_MESSAGE": "Il tavolo apre alle",
    "LIVE_CASINO_TABLE_FULL_PC": "Tavolo completo",
    "LIVE_CASINO_TABLE_FULL_MOBILE": "Completo",
    "GAME_SHOWS": "Game Shows",
    "TOP_EVO_GAMES": "Top giochi",
    "FOR_YOU_GAMES": "PER TE",
    "LETS_PLAY_MONOPOLY": "Giochiamo a Monopoly",
    "TOP_TRENDING_SLOTS": "Slot più popolari",
    "TOP_PAYING_SLOTS": "Slot più vincenti",
    "RECENTLY_ADDED": "Aggiunte di recente",
    "TOP_SLOTS": "Le migliori Slot",
    "VIRTUAL_SPORTS": "Sport Virtuali",
    "INFO_TITLE_ARENA_VIRTUAL_SPORTS": "Sport Virtuali",
    "INFO_TEXT_ARENA_VIRTUAL_SPORTS": "Con gli Sport Virtuali hai un'ampia gamma di eventi sportivi simulati al computer su cui scommettere ogni volta che vuoi: così mentre aspetti una partita importante o un grande evento puoi ingannare l'attesa con una scommessa sui Virtuali.",
    "MINI_ORBIT_BALANCE": "Saldo:",
    "REAL_MONEY_GAME": "È possibile giocare a questa partita solo con il saldo del denaro contante.",
    "NEW_GAMES_LIST_TITLE": "Nuovi giochi di casino online",
    "NEW_GAMES": "Nuovi giochi",
    "TOP_EXCLUSIVE_SLOTS": "Top Exclusive Slots",
    "TOP_10_IN_YOUR_COUNTRY": "Top 10 in your country",
    "CANT_CONNECT_ERROR_TITLE": "Connessione non effettuata",
    "CANT_CONNECT_ERROR_MESSAGE": "Spiacenti, si è verificato un problema.",
    "RETRY": "RIPROVA",
    "ALL_CIP_GAMES": "TUTTI I GIOCHI",
    "TRANSACTION_HISTORY": "Cronologia delle transazioni",
    "GAME_POPUP_GAME_UNAVAILABLE": "Siamo spiacenti, questo gioco non è disponibile",
    "GAME_POPUP_MAY_LIKE": "Ti potrebbe piacere:",
    "PARTY_JACKPOT_WELCOME_POPUP_TITLE": "EVVIVA! Stai per giocare a {partyJackpotName}!",
    "PARTY_JACKPOT_WELCOME_POPUP_TITLE_ALL_LIVE_CASINO": "LUCKY YOU!",
    "PARTY_JACKPOT_WELCOME_POPUP_SUB_TITLE_ALL_LIVE_CASINO": "All Live Casino games are part of our HOT NEW jackpot!",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION": "Puoi vincere il Jackpot ad ogni puntata effettuata con Denaro reale.\nI premi Party Jackpot sono assegnati sotto forma di Bonus immediatamente disponibili sul tuo conto.",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL": "Ad ogni puntata con denaro reale in una slot Party Jackpot puoi vincere un premio extra!\n Il Party Jackpot verrà pagato ogni giorno!",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL_HOURLY": "Any real money bet on a Party Jackpot game could win a cash prize!\nThe Party Jackpot will pay hourly between {startHour} to {endHour}",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL_HOURLY_ALL_LIVE_CASINO": "Real money bets on any Live Casino game could win the jackpot! The Live Casino Jackpot must pay every hour, {startHour} - {endHour}, and is fully funded by us.",
    "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE": "Bonus: Requisito di puntata pari a 30 (la contribuzione varia in base al gioco), valido 90 giorni, utilizzabile solo su giochi specifici",
    "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE_REAL": "Solo per i giocatori che hanno ricaricato il conto di gioco",
    "PARTY_JACKPOT_WELCOME_POPUP_TERMS_AND_CONDITIONS_APPLY": "Si applicano Termini e condizioni.",
    "PARTY_JACKPOT_WIN_TOASTER_TITLE": "Il {jackpotName} da {winAmount} è appena uscito!",
    "PARTY_JACKPOT_WIN_TOASTER_SUBTITLE": "Non hai vinto? Non preoccuparti!\n Questo Jackpot esce ogni ora, {startHour}-{endHour}.",
    "PARTY_JACKPOT_WIN_POPUP_YOU_WON": "HAI VINTO IL {jackpotName}",
    "PARTY_JACKPOT_WIN_POPUP_AWESOME": "OTTIMO!",
    "PARTY_JACKPOT_OUT_OF_CASH_TOASTER_TITLE": "Ricarica per provare a vincere il Jackpot del Live Casino",
    "PARTY_JACKPOT_OUT_OF_CASH_TOASTER_SUBTITLE": "Il Jackpot del Live Casino può essere vinto solo utilizzando denaro reale",
    "JACKPOT-WIDGET-MUST-PAY": "Pagamento entro:",
    "JACKPOT-WIDGET-DROPS-SOON": "SARÀ PAGATO TRA POCO!",
    "JACKPOT-WIDGET-STARTS-SOON": "INIZIA TRA POCO",
    "JACKPOT-WIDGET-NEXT-JACKPOT": "Lancio del prossimo Jackpot in corso",
    "JACKPOT-WIDGET-LAST-WIN": "Ultima vincita",
    "IN-GAME-WIDGET-STARTS-SOON": "Inizia tra poco",
    "FREEPLAY_INDICATOR": "Giocate Gratis",
    "OMG_INDICATOR": "Notifiche",
    "USER_LIKE_YOU": "TOP {topNumber} IN {countryName}",
    "YOUR_COUNTRY": "Il tuo Paese",
    "CLOSE": "Chiudi",
    "LIVE_STREAM_WATCH_TIME_REACHED": "Pronto per iniziare a giocare?",
    "LIVE_STREAM_VIDEO_LOADING": "Caricamento in corso...",
    "PLAY_NOW": "GIOCA ORA",
    "CASINO": "CASINÒ",
    "PAYMENTS_REDIRECT_FOCUS_TITLE": "Ricarica in fase di elaborazione",
    "PAYMENTS_REDIRECT_FOCUS_TEXT": "La tua schermata {mftName} è ancora aperta",
    "PAYMENTS_REDIRECT_FOCUS_CTA": "Continua",
    "VOLATILE_SLOTS": "Volatilità delle Slot",
    "VOLATILE_GAMES": "Volatilità dei Giochi",
    "HIGH_VOLATILITY_SLOTS": "Slot ad alta volatilità",
    "LOW_VOLATILITY_SLOTS": "Bassa volatilità (Vincite più frequenti e di importi più bassi)",
    "BURNOUT_MESSAGE_LINE_1": "SORPRESA!",
    "BURNOUT_MESSAGE_LINE_2": "HAI RICEVUTO UN BONUS!",
    "CONGRATS": "Congratulazioni!",
    "YOUR_FP_ARE_WAITING": "Le tue Giocate Gratis sono qui",
    "EXIT_POPUP_TITLE": "Potrebbe Anche Piacerti",
    "DONT_SHOW_AGAIN_TEXT": "Non mostrare più questo messaggio",
    "DAILY_DEAL_WIDGET_STRIP": "I GIORNALIERI",
    "GAMING_HISTORY_NO_RECORDS": "Impossibile individuare record della cronologia delle tue partite",
    "GAMING_HISTORY_LAST_PAGE": "Impossibile trovare altri record della cronologia.",
    "GAMING_HISTORY_BET": "Puntata",
    "GAMING_HISTORY_WINNINGS": "Vincite",
    "GAMING_HISTORY_WINNINGS_BONUS_CAP": "Vincite*",
    "GAMING_HISTORY_BANKROLL": "Credito di gioco",
    "GAMING_HISTORY_MORE_DETAILS": "Altri dettagli",
    "GAMING_HISTORY_MORE_DETAILS_NOT_AVAILABLE_PC": "Disponibile solo su dispositivi mobili",
    "GAMING_HISTORY_MORE_DETAILS_NOT_AVAILABLE_MOBILE": "Disponibile solo su PC",
    "GAMING_HISTORY_FREE_PLAY_BET": "Puntata*",
    "GAMING_HISTORY_FREE_PLAY_WINNINGS": "Vincite*",
    "GAMING_HISTORY_FREE_PLAY_REWARD_WINNINGS": "Vincite premi",
    "GAMING_HISTORY_FREE_PLAY_REWARD_BANKROLL": "Credito di gioco premi",
    "GAMING_HISTORY_FREE_PLAY_INDICATION": "* Giocato con premi",
    "GAMING_HISTORY_FREE_PLAY_MAX_CUP_INDICATION": "* Vincita max",
    "GAMING_HISTORY_DAYS_INTERVAL": "Ultimi {numberOfDays} giorni",
    "GAME_PARTICIPATION_ID": "ID partecipazione: {participationID}",
    "GAME_SESSION_ID": "ID sessione: {sessionID}",
    "IDLE_RECOMMENDATIONS_TITLE": "Non sai decidere a cosa giocare?",
    "IDLE_RECOMMENDATIONS_SECOND_TITLE": "Perché non provi:",
    "GAME_WINDOW_VENDOR_SESSION_ID": "ID sessione: {sessionID}",
    "GAME_WINDOW_MODE_REAL_LABEL": "Gioco con Denaro",
    "GAME_WINDOW_MODE_DEMO_LABEL": "Demo",
    "FREE_PLAY_VOUCHER_NAME_FPV": "Giocate gratis",
    "FREE_PLAY_VOUCHER_NAME_FSV": "Giocate gratis",
    "FREE_PLAY_VOUCHER_NAME_JPFPV": "Giocate gratis Jackpot",
    "FREE_PLAY_VOUCHER_NAME_JPFSV": "Giri Jackpot",
    "FREE_PLAY_VOUCHER_BALANCE_PREFIX": "Rimanente/i:",
    "FREE_PLAY_VOUCHER_TITLE_FPV": "Giocate gratis ottenute",
    "FREE_PLAY_VOUCHER_TITLE_FSV": "Giocate gratis ottenute",
    "FREE_PLAY_VOUCHER_TITLE_JPFPV": "Giocate gratis Jackpot ottenute",
    "FREE_PLAY_VOUCHER_TITLE_JPFSV": "Giri Jackpot ottenuti",
    "FREE_PLAY_VOUCHER_DESC_FPV": "Denaro per giocate gratis sui giochi selezionati in qualsiasi modalità!",
    "FREE_PLAY_VOUCHER_DESC_FSV": "Giocate gratis con valori predefiniti da utilizzare su giochi selezionati!",
    "FREE_PLAY_VOUCHER_DESC_JPFPV": "Denaro per giocate gratis solo Jackpot sui giochi selezionati in qualsiasi modalità!",
    "FREE_PLAY_VOUCHER_DESC_JPFSV": "Giri gratis solo Jackpot con valori predefiniti da utilizzare su giochi selezionati!",
    "FREE_PLAY_VOUCHER_REWARD_AMOUNT": "{amount} {fp_voucher_name}",
    "FREE_PLAY_VOUCHER_REWARD_BALANCE": "{fp_voucher_remaining_prefix} {balance}",
    "FREE_PLAY_EXPIRES_IN_TIME": "Scade fra: {expiration}",
    "FREE_PLAY_EXPIRES_IN_EXPIRED": "Scaduto/a",
    "FREE_PLAY_EXPIRES_IN_DAY": "Scade tra {expiration} giorni",
    "FREE_PLAY_MESSAGE_VOUCHER_TITLE_GOOD_LUCK": "In bocca al lupo!",
    "FREE_PLAY_MESSAGE_LIST_TITLE": "Ti aspettano dei premi. In bocca al lupo!",
    "FREE_PLAY_MESSAGE_SELECTED_GAME_TITLE": "Questa partita può essere disputata con i seguenti premi:",
    "FREE_PLAY_MESSAGE_GAMES_LIST_TITLE": "Puoi utilizzare il premio nel gioco/nei giochi in basso.",
    "FREE_PLAY_MESSAGE_NO_VOUCHERS": "Non sono presenti premi disponibili",
    "FREE_PLAY_MESSAGE_BACK_TO_VOUCHERS": "Indietro",
    "FREE_PLAY_SHOW_MORE": "Mostra Più",
    "FREE_PLAY_SHOW_LESS": "Mostra Meno",
    "FREE_PLAY_USE_NOW_BUTTON": "Utilizzalo ora",
    "FREE_PLAY_USE_LATER_BUTTON": "Utilizzalo dopo",
    "FREE_PLAY_SUGGESTION_DIALOG_TITLE": "Questo gioco ti regala dei premi!",
    "BONUS_ABUSE_PREVENTION_TITLE": "Gioco disconnesso",
    "BONUS_ABUSE_PREVENTION_MESSAGE": "A quanto pare, c'è un gioco che è stato disconnesso....\n Completa {gameName} prima di iniziare a giocare a {newGameName}.",
    "BONUS_ABUSE_PREVENTION_NOT_NOW_BTN": "Non ora",
    "BONUS_ABUSE_PREVENTION_COMPLETE_BTN": "Gioco completo",
    "OPEN_GAME_FROM_CHALLENGES": "Le missioni non possono essere completate utilizzando i premi.",
    "CANCEL": "Annulla",
    "YES": "SÌ",
    "NO": "No",
    "ONE_GAME_PER_SESSION_DIALOG_TITLE": "Apri il gioco",
    "ONE_GAME_PER_SESSION_DIALOG_MESSAGE": "Sembra che il gioco sia ancora aperto...\n Chiudi {oldGameName} e inizia a giocare a {newGameName}",
    "GAMES_OF_THE_WEEK": "Games Of The Week",
    "THE_FISH_MARKET": "The Fish Market",
    "LETS_PLAY_POKER": "Lets Play Poker!",
    "HYBRID_EMBEDDED_GAME_LOADING_SLOW_CONNECTION_TOASTER_TITLE": "Connessione lenta",
    "HYBRID_EMBEDDED_GAME_LOADING_SLOW_CONNECTION_TOASTER_SUBTITLE": "Abbiamo rilevato una connessione lenta. Per aprire il gioco potrebbe essere necessario più tempo del previsto.",
    "HYBRID_EMBEDDED_GAME_LOADING_SPINNER_LABEL": "Connessione in corso...",
    "HYBRID_EMBEDDED_GAME_LOADING_PACKAGES_PROGRESS": "Preparazione del gioco {packagesStatus}",
    "HELP_CENTER": "Centro Assistenza",
    "ABOUT_TITLE": "I dettagli del tuo conto",
    "ABOUT_SUPPORT_ID_TITLE": "ID per assistenza",
    "ABOUT_FISCAL_CODE_TITLE": "Codice fiscale",
    "ABOUT_CLIENT_VERSION_TITLE": "Versione del client",
    "ABOUT_HELP_SUPPORT": "Per domande relative all'assistenza, leggi la nostra Guida online.",
    "ABOUT_OPEN_SESSION_TITLE": "Saldo sessioni aperte",
    "OK": "OK",
    "INSUFFICIENT_FUNDS_TITLE": "Saldo insufficiente",
    "INSUFFICIENT_FUNDS_MESSAGE": "Il saldo attuale non è sufficiente per questa partita.\nEffettua una nuova ricarica per continuare a giocare.",
    "OPEN_CASHIER": "Vai alla Cassa",
    "GAME_LIMIT_REAL_MONEY_WARNING_MESSAGE": "È possibile giocare a questa partita solo con il saldo del denaro contante.",
    "GAME_NET_POSITION_LABEL": "Bankroll",
    "GAME_DURATION_LABEL": "Durata del gioco",
    "GAME_LIMIT_TITLE": "Scegli il Denaro del Gioco",
    "REGULATORY_LIMIT_LABEL": "Limite Normativo:",
    "OTHER_LIMIT_LABEL": "Altro:",
    "GAME_LIMIT_VALUE_ERROR": "Immissione non valida. Riprova.",
    "GAME_LIMIT_REGULATION_ERROR": "Importo massimo: {regulationLimit}. Riprova.",
    "GAME_LIMIT_MIN_BET_ERROR": "Importo inferiore al minimo del tavolo. Riprova.",
    "Adventure": "Avventura",
    "Ancient Civilization": "Antiche Civiltà ",
    "Arabic": "Arabo",
    "Asian": "Asiatico",
    "Classic Style": "Stile tradizionale",
    "Comics and Cartoons": "Fumetti e Cartoni",
    "Diamonds and Gems": "Diamanti e Pietre",
    "Egyptian": "Egiziano",
    "Fantasy and Folklore": "Fantasy e Folklore",
    "Farm and Pets": "Fattoria e Animali",
    "Fish": "Pesci",
    "Fruit and Candy": "Frutta e Dolci",
    "Greek Mythology": "Mitologia greca",
    "Irish": "Irlandese",
    "Money and Leisure": "Soldi e Lusso",
    "Movies and Music": "Film e Musica",
    "Seasonal": "Stagionalità",
    "Space and Sci-fi": "Spazio e Fantascienza",
    "Wildlife": "Natura",
    "GAME_STUDIOS": "Game studios",
    "THEMES": "Temi",
    "GAME_FEATURES": "Funzionalità",
    "GAME_CATEGORIES": "Categorie",
    "FILTER_BY": "Filtra per",
    "NO_JACKPOT": "Nessun jackpot",
    "HIGH_STAKES": "Livelli alti",
    "LOW_STAKES": "Livelli bassi",
    "MULTIHAND": "Multihand",
    "LIVE_BACCARAT": "Live Baccarat ",
    "LIVE_POKER": "Live Poker ",
    "LIVE_GAME_SHOWS": "Giochi dal vivo",
    "CRAPS": "Craps",
    "LIVE_ROULETTE": "Live Roulette",
    "MEDIUM_VOLATILITY": "Volatilità media",
    "VOLATILITY": "Volatilità",
    "HIGH_VOLATILITY": "Volatilità alta",
    "LOW_VOLATILITY": "Volatilità bassa",
    "SPEED_GAMES": "Giochi Rapidi",
    "generic_notification_popup_title": "Comunicazione",
    "MDP_INACTIVITY_DISCONNECTED_TEXT": "Sei stato disconnesso a causa di un periodo di inattività.",
    "RICH_USER_NOT_LOGGED_IN": "Accedi per visualizzare le tue missioni",
    "temp_account_title": "Conferma il tuo Conto entro",
    "temp_account_upload_btn": "CARICA IL DOCUMENTO",
    "temp_account_days_left": "Giorni",
    "MENU_ITEM_ABOUT": "Informazioni",
    "MENU_ITEM_GAMING_REMINDERS": "Promemoria orario di gioco",
    "MENU_ITEM_TOUCH_ID": "Login biometrico",
    "MENU_ITEM_INACTIVITY_TIMEOUT_SETTINGS": "Impostazioni",
    "MENU_ITEM_HYBRID_INFO": "Info",
    "MENU_ITEM_CASHIER_VERIFY_ID": "Verifica identità",
    "TOUCH_ID_SUB_CAPTION": "Questa funzione verrà attivata al tuo prossimo accesso",
    "TOUCH_ID_CAPTION": "Puoi fare il login più velocemente con le funzioni Touch/Face ID sul tuo dispositivo.",
    "TERMS_AND_CONDITIONS": "Termini e condizioni",
    "TOUCH_ID_INIT_SCREEN_ENABLE_BUTTON": "ATTIVA SUBITO",
    "TOUCH_ID_AUTO_SCREEN": "LOGIN CON TOUCH/FACE ID",
    "kick_reason_general": "Sei stato disconnesso dal tuo conto",
    "kick_reason_20": "Sei stato disconnesso dal conto perché ti sei registrato da un'altra posizione",
    "ONBOARDING_WELCOME_STEP_MAIN_TEXT": "Più giochi. Jackpot più ricchi. Un'esperienza di gioco personalizzata.",
    "ONBOARDING_WELCOME_STEP_SECONDARY_TEXT": "Sei pronto ad esplorare la tua nuova casa?",
    "ONBOARDING_MENU_STEP_MAIN_TEXT": "Questo magico menù ti porterà direttamente nel PIENO divertimento",
    "ONBOARDING_MENU_STEP_SECONDARY_TEXT": "Jackpot, slot, tavoli LIVE e promozioni",
    "ONBOARDING_USER_AREA_MAIN_TEXT": "Gestisci il tuo account da un unico posto",
    "ONBOARDING_USER_AREA_SECONDARY_TEXT": "nformazioni sull'account, cronologia delle transazioni, panoramica dei bonus e molto altro",
    "NEXT": "Avanti",
    "DONE": "Fine",
    "TOUCH_ID_INFO": "<li>L'attivazione della funzione Touch/Face ID su questo dispositivo consentirà a tutti gli utenti con le impronte digitali salvate sul dispositivo di accedere al tuo conto 888. Non impostare la funzione se sul dispositivo sono salvate altre impronte digitali oltre alle tue.</li><li>Utilizzando Touch/Face ID per accedere al conto 888, accetti di essere il solo responsabile per qualsiasi transazione sul conto, indipendentemente dal fatto che sia stata effettuata da un terzo o da qualsiasi altra persona con le impronte digitali salvate sul dispositivo.</li><li>Inoltre, accetti che l'operatore dell'applicazione e i suoi affiliati (insieme \"Gruppo 888\") non saranno responsabili per qualsiasi conseguenza legata all'utilizzo di Touch/Face ID per accedere al conto 888. Il Gruppo 888 non sarà responsabile per qualsiasi perdita, responsabilità, danno, spesa o costo legati all'utilizzo della funzionalità.</li><li>Per ogni applicazione di 888 presente sul tuo dispositivo, potrai configurare un solo conto alla volta al quale accedere con Touch/Face ID.</li><li>Quando l'autenticazione di Touch/Face ID non riesce o scade, dovrai accedere utilizzando la password.</li><li>Il Gruppo 888 non salva le tue impronte digitali sui suoi server e non gestisce o supporta la tecnologia Touch/Face ID.</li>",
    "TABLE_GAMES": "Giochi da tavolo",
    "ARCADE": "Arcade",
    "SPORTS": "Sport",
    "SCRATCH_CARDS": "Instant Games",
    "MEXICAN": "Messicano",
    "BINGO": "Bingo",
    "CLASSIC_STYLE_MODERNIZED": "Stile classico in chiave moderna",
    "AZTEC_INCA_MAYAN": "Aztechi - Inca - Maya",
    "CRIME": "Crimine",
    "WILD_WEST": "Selvaggio West",
    "CANDY_AND_SWEETS": "Dolci e caramelle",
    "GOLD_MINING": "Estrazione dell'oro",
    "VIKINGS_AND_NORDIC_MYTHOLOGY": "Vichinghi e mitologia nordica",
    "XMAS": "Natale",
    "LAST_LOGIN_TITLE": "Ultimo login:",
    "LIVE_SLOTS": "Live Slots",
    "THE_BOOK_SHELF": "The Book Shelf",
    "LUCKYTAP_GAMES": "LuckyTap Games",
    "VEGAS_SLOTS": "Vegas Slots",
    "MUSIC_TO_MY_EARS": "Music to my ears",
    "GENIES_JACKPOT": "Genie's Jackpot",
    "NEW_LIVE_CASINO_GAMES": "New Live Casino Games",
    "EXIT_GAME_POPUP_TITLE": "Esci dal gioco",
    "EXIT_GAME_POPUP_TEXT": "Sei sicuro di voler lasciare il gioco?",
    "CROSS_POKER_ICON_ALT_TEXT": "Online Poker",
  }
}